import _ from "lodash";
import { triggerState, handleChange } from '../config'
const origin = {
  thebase: {
    companyName: "",//String	维保单位名称
    companyNumber: "",//String	维保单位营业执照号
    companyPerson: "",//String	维保单位联系人
    companyPhone: "",//String	维保单位联系人电话
    startDate: "",//String	合同开始日期，年月日
    endDate: "",//String	合同结束日期，年月日
    contractFile: "",//String	合同pdf预览      
    empId: "",//维保合同业务处理人
  },
  xc: {
    typeId: 1,
    period: "",//执行周期 必填
    periodNum: 1,//:0次数必填大于0
    typeInfoId: []//条目
  },
  jc: {
    typeId: 2,
    period: "",//执行周期 必填
    periodNum: 1,//:0次数必填大于0
    typeInfoId: []//条目
  },
  by: {
    typeId: 3,
    period: "",//执行周期 必填
    periodNum: 1,//:0次数必填大于0
  }
}
const states = {
  namespace: 'wbhtgl',
  wbId: 0,
  s_status: "adding",//当前modal的状态
  required: false,
  readonly: false,
  thebase: {
    ..._.cloneDeep(origin.thebase),
    valid: true
  },
  xc: {
    ..._.cloneDeep(origin.xc),
    required: false,
    readonly: true,
    checked: false,
    valid: true
  },
  jc: {
    ..._.cloneDeep(origin.jc),
    required: false,
    readonly: true,
    checked: false,
    valid: true
  },
  by: {
    ..._.cloneDeep(origin.by),
    required: false,
    readonly: true,
    checked: false,
    valid: true
  },
  init: function () {
    this.xc.parent = () => this;
    this.jc.parent = () => this;
    this.by.parent = () => this;
    delete this.init;
    return this;
  }
}.init();
export default {
  namespaced: true,
  state: handleChange({ states, namespace: states.namespace }),
  mutations: {
    reset(state) {
      triggerState({
        state, property: "xc", payload: {
          ..._.cloneDeep(origin.xc),
          required: false,
          readonly: true,
          checked: false,
          valid: true,
          parent: () => state
        }, namespace: states.namespace
      });
      triggerState({
        state, property: "jc", payload: {
          ..._.cloneDeep(origin.jc),
          required: false,
          readonly: true,
          checked: false,
          valid: true,
          parent: () => state
        }, namespace: states.namespace
      });
      triggerState({
        state, property: "by", payload: {
          ..._.cloneDeep(origin.by),
          required: false,
          readonly: true,
          checked: false,
          valid: true,
          parent: () => state
        }, namespace: states.namespace
      });
      triggerState({ state, property: "thebase", payload: origin.thebase, namespace: states.namespace });

    },
    changeStatus(state, payload) {
      if (payload == "readonly" || payload == "editing") {
        delete state["xc"].readonly;
        delete state["xc"].required;
        delete state["jc"].readonly;
        delete state["jc"].required;
        delete state["by"].readonly;
        delete state["by"].required;
        state.readonly = true;
        state.required = false;
        state["thebase"].valid = state["xc"].valid = state["jc"].valid = state["by"].valid = true;
      }
      triggerState({ state, property: "s_status", payload, namespace: states.namespace });
    },
    changeWbId(state, payload) {
      triggerState({ state, property: "wbId", payload, namespace: states.namespace });
    },
    changeModel(state, payload) {
      let { name, key, value } = payload;
      //修改值
      state[name][key] = value;
      //必填
      // if (["xc", "jc", "by"].includes(name)) {
      //   let required = false;
      //   for (let k in origin[name]) {
      //     if (!_.isEqual(state[name][k], origin[name][k])) {
      //       required = true;
      //     }
      //   }
      //   state[name].required = required;
      // }
      triggerState({ state, property: name, payload: state[name], namespace: states.namespace });
    }
  },
  actions: {

  },
  getters: {
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/wbhtgl.js